import { useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { sendUserTTCLID } from 'root-redux/actions/user'
import { selectTiktokPixelId } from 'root-redux/selects/common'
import { selectEmail, selectUUID } from 'root-redux/selects/user'

import { useCookieConsentAnswer } from './useCookieConsentAnswer'

export const useTiktokPixelInitialization = (): void => {
  const dispatch = useDispatch()
  const tiktokPixelId = useSelector(selectTiktokPixelId)
  const email = useSelector(selectEmail)
  const uuid = useSelector(selectUUID)
  const { canUseAdvertising } = useCookieConsentAnswer()

  useLayoutEffect(() => {
    if (!tiktokPixelId || !uuid) return

    const searchParams = new URLSearchParams(document.location.search)
    const ttclid = searchParams.get('ttclid')

    if (ttclid) dispatch(sendUserTTCLID(ttclid))

    if (!canUseAdvertising) {
      return
    }

    window.ttq.load(tiktokPixelId)
    window.ttq.identify({ email })
    window.ttq.page({ event_id: uuid })
  }, [dispatch, email, canUseAdvertising, tiktokPixelId, uuid])
}
